import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'negocio-rentable-bonus-deadline';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getDeadline(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  const parsed = stored ? Number(stored) : NaN;
  if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
  const next = Date.now() + DURATION_MS;
  window.localStorage.setItem(STORAGE_KEY, String(next));
  return next;
}
function pad(value: number): string {
  return String(Math.max(0, value)).padStart(2, '0');
}
export function Countdown() {
  const [deadline, setDeadline] = useState<number>(() => Date.now() + DURATION_MS);
  const [remaining, setRemaining] = useState<number>(DURATION_MS);
  useEffect(() => {
    const target = getDeadline();
    setDeadline(target);
    setRemaining(target - Date.now());
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [deadline]);
  const hours = Math.floor(remaining / 3_600_000);
  const minutes = Math.floor(remaining % 3_600_000 / 60_000);
  const seconds = Math.floor(remaining % 60_000 / 1000);
  const blocks = [{
    value: pad(hours),
    label: 'Horas'
  }, {
    value: pad(minutes),
    label: 'Minutos'
  }, {
    value: pad(seconds),
    label: 'Segundos'
  }];
  return <div className="rounded-2xl border border-black/10 bg-black px-6 py-6 text-center" data-id="element-23" data-mp="f2kgpmb99yik">
      <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-sage" data-id="element-24" data-mp="a4sjqdvr7m7i">
        🎁 Bonos gratis solo por hoy
      </p>
      <div className="mt-4 flex items-start justify-center gap-3" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-25" data-mp="k1f1gtss9x5b">
        {blocks.map((block, i) => <React.Fragment key={block.label} data-id="element-26" data-mp="1vg0ybfgjgxr9" data-mpi={i}>
            {i > 0 && <span className="pt-2 font-display text-2xl font-extrabold text-sage/60" aria-hidden="true" data-id="element-27" data-mp="s6g1741pkrdf">
                :
              </span>}
            <div className="min-w-[74px] rounded-xl bg-white/10 px-3 py-3" data-id="element-28" data-mp="x6kmr8hh4cai">
              <span className="block font-display text-3xl font-extrabold tabular-nums text-white" data-id="element-29" data-mp="124m2pkjlrvhr">
                {block.value}
              </span>
              <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.16em] text-sage" data-id="element-30" data-mp="9fow4eor7n4u">
                {block.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}